import clsx from "clsx";

interface ButtonProps {
  id?: string;

  label: string;

  labelClassName?: string;

  /**
   * Default: 'button'
   */
  type?: "button" | "submit" | "reset";

  /**
   * Default: 's'
   */
  size?: "xs" | "s" | "m" | "l";

  /**
   * Default: 'primary'
   */
  theme?: "primary" | "secondary" | "tertiary" | "danger" | "none";

  /**
   * Default: false
   */
  disabled?: boolean;

  onClick?: () => void;

  /**
   * Default: ""
   */
  className?: string;

  /**
   * Default: ''
   */
  containerClassName?: string;

  width?: number | string;

  icon?: string;

  /**
   * Default: ''
   */
  iconClassName?: string;
}

function Button({
  id,
  label,
  labelClassName = "",
  type = "button",
  className = "",
  containerClassName = "",
  theme = "primary",
  size = "s",
  disabled = false,
  onClick = () => {},
  width = 80,
  icon,
  iconClassName,
}: ButtonProps) {
  return (
    <div style={{ width }} className={`${containerClassName}`}>
      <button
        className={clsx(`w-full rounded-xl relative ${className}`, {
          "leading-[26px]": size === "xs",
          "h-[26px]": size === "xs",
          "leading-[36px]": size === "s",
          "h-[36px]": size === "s",
          "leading-[40px]": size === "m",
          "h-[40px]": size === "m",
          "leading-[58px]": size === "l",
          "h-[58px]": size === "l",
          "bg-color-primary hover:bg-[#667ffc] text-white": theme === "primary",
          "hover:bg-[#e60000] hover:text-white": theme === "danger",
          "border border-solid border-[#e60000]": theme === "danger",
          "bg-[#29b6f6] hover:bg-[#81d4fa]": theme === "tertiary",
          "bg-white text-[#5570F1] hover:bg-[#667ffc]": theme === "secondary",
          "border-[2px] border-solid border-[#5570F1] hover:text-white":
            theme === "secondary",
          "!bg-[gray] text-white from-gray-500 to-gray-600": disabled,
        })}
        id={id}
        type={type}
        disabled={disabled}
        onClick={onClick}
      >
        {icon && (
          <img
            className={`absolute w-5 h-5 left-[15px] top-[14px] ${iconClassName}`}
            src={icon}
            alt=""
          />
        )}
        <span className={`${labelClassName}`}>{label}</span>
      </button>
    </div>
  );
}

export default Button;
